// extracted by mini-css-extract-plugin
export default {"tariffs_page":"Tariffs_tariffs_page__VJrrR"};